"use client";

import { useState } from "react";

interface NewsletterSectionProps {
  showToast: (msg: string) => void;
}

export default function NewsletterSection({ showToast }: NewsletterSectionProps) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailToggle, setEmailToggle] = useState(true);
  const [smsToggle, setSmsToggle] = useState(true);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail("");
    setPhone("");
    showToast("Registrering bekreftet! Du vil motta nyheter fra SebNorge.");
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .newsletter-inputs {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
          .newsletter-btn {
            width: 100% !important;
          }
          .newsletter-toggles {
            gap: 20px !important;
          }
        }
      `}</style>
      <section
        style={{
          position: "relative",
          borderTop: "1px solid #2A2A2A",
          padding: "100px 0",
          overflow: "hidden"
        }}>
        
        {/* Background image */}
        <div style={{ position: "absolute", inset: 0, zIndex: 0 }}>
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_10d8076db-1772554036629.png"
            alt="Norwegian technology dark background"
            loading="lazy"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block"
            }} />
          
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.88)" }} />
        </div>

        <div className="max-w-5xl mx-auto px-6" style={{ position: "relative", zIndex: 1 }}>
          <div className="text-center mb-12">
            <p className="section-label" style={{ marginBottom: "16px" }}>Nyhetsbrev</p>
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "clamp(2rem, 5vw, 3.5rem)",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                color: "white",
                lineHeight: 1.05,
                marginBottom: "20px"
              }}>
              
              Aldri gå glipp av en oppdatering
            </h2>
            <p
              style={{
                fontFamily: "Nunito Sans, sans-serif",
                fontSize: "1rem",
                color: "rgba(255,255,255,0.5)",
                lineHeight: 1.7,
                maxWidth: "560px",
                margin: "0 auto"
              }}>
              
              Registrer deg for å motta nye maskiner, programvareoppdateringer og eksklusive SebNorge-nyheter direkte på SMS og e-post.
            </p>
          </div>

          <form onSubmit={handleSubmit} style={{ maxWidth: "600px", margin: "0 auto" }}>
            <div className="newsletter-inputs" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginBottom: "24px" }}>
              <div>
                <label className="section-label" style={{ display: "block", marginBottom: "8px" }}>E-postadresse</label>
                <input
                  type="email"
                  className="input-line"
                  placeholder="din@epost.no"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required />
                
              </div>
              <div>
                <label className="section-label" style={{ display: "block", marginBottom: "8px" }}>Mobilnummer</label>
                <input
                  type="tel"
                  className="input-line"
                  placeholder="+47 000 00 000"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)} />
                
              </div>
            </div>

            <div className="newsletter-toggles" style={{ display: "flex", gap: "32px", marginBottom: "24px", justifyContent: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <label className="toggle-switch">
                  <input type="checkbox" checked={emailToggle} onChange={(e) => setEmailToggle(e.target.checked)} />
                  <span className="toggle-slider" />
                </label>
                <span style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "0.75rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.6)" }}>E-post</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <label className="toggle-switch">
                  <input type="checkbox" checked={smsToggle} onChange={(e) => setSmsToggle(e.target.checked)} />
                  <span className="toggle-slider" />
                </label>
                <span style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "0.75rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.6)" }}>SMS</span>
              </div>
            </div>

            <button type="submit" className="btn-full-white newsletter-btn">Registrer meg →</button>

            <p style={{ fontFamily: "Nunito Sans, sans-serif", fontSize: "0.72rem", color: "rgba(255,255,255,0.3)", textAlign: "center", marginTop: "16px" }}>
              Vi deler aldri dine opplysninger. Avslutt abonnementet når som helst.
            </p>
          </form>
        </div>
      </section>
    </>
  );
}